import {
  FilterProvider,
  PaginationProvider,
  SortProvider,
  PageViewProvider,
} from 'dash-ui';

import AlertPropertiesList from './components/AlertPropertiesList/AlertPropertiesList';
import AlertsTopBar from './components/AlertsTopBar/AlertsTopBar';

import AddPropertyToPortfolioModal from 'containers/portfolio/AddPorpertyToPortfolioModal/AddPropertyToPortfolioModal';
import RemoveAlertModal from 'containers/alerts/RemoveAlertModal/RemoveAlertModal';
import AlertListModal from 'containers/alerts/AlertListModal/AlertListModal';

const AllAlertsPropertiesContainer = () => (
  <FilterProvider>
    <SortProvider>
      <PageViewProvider>
        <>
          <PaginationProvider>
            <>
              <AlertsTopBar />
              <AlertPropertiesList />
              <AddPropertyToPortfolioModal />
              <RemoveAlertModal />
            </>
          </PaginationProvider>
          <PaginationProvider>
            <AlertListModal />
          </PaginationProvider>
        </>
      </PageViewProvider>
    </SortProvider>
  </FilterProvider>
);

export default AllAlertsPropertiesContainer;
